// Données géographiques pour Afrique centrale et de l'ouest
export interface Country {
    code: string;
    name: string;
    regions: Region[];
    phonePrefix: string;
    languages: string[];
}

export interface Region {
    name: string;
    cities: string[];
}

export const africanCountries: Country[] = [
    {
        code: 'CM',
        name: 'Cameroun',
        phonePrefix: '+237',
        languages: ['fr', 'en'],
        regions: [
            {
                name: 'Centre',
                cities: ['Yaoundé', 'Obala', 'Mfou', 'Nanga-Eboko']
            },
            {
                name: 'Littoral',
                cities: ['Douala', 'Édéa', 'Loum', 'Penyé']
            },
            {
                name: 'Ouest',
                cities: ['Bafoussam', 'Dschang', 'Foumban', 'Bamenda']
            },
            {
                name: 'Nord-Ouest',
                cities: ['Bamenda', 'Bali', 'Kumbo', 'Wum']
            },
            {
                name: 'Sud-Ouest',
                cities: ['Buea', 'Limbe', 'Kumba', 'Mamfe']
            },
            {
                name: 'Nord',
                cities: ['Garoua', 'Maroua', 'Guider', 'Mora']
            },
            {
                name: 'Adamaoua',
                cities: ['Ngaoundéré', 'Tibati', 'Meiganga', 'Banyo']
            },
            {
                name: 'Est',
                cities: ['Bertoua', 'Batouri', 'Abong-Mbang', 'Yokadouma']
            },
            {
                name: 'Sud',
                cities: ['Ebolowa', 'Ambam', 'Kribi', 'Sangmélima']
            },
            {
                name: 'Extrême-Nord',
                cities: ['Maroua', 'Kousséri', 'Mokolo', 'Yagoua']
            }
        ]
    },
    {
        code: 'GA',
        name: 'Gabon',
        phonePrefix: '+241',
        languages: ['fr'],
        regions: [
            {
                name: 'Estuaire',
                cities: ['Libreville', 'Ntoum', 'Kango', 'Cocobeach']
            },
            {
                name: 'Haut-Ogooué',
                cities: ['Franceville', 'Moanda', 'Mounana', 'Lékoni']
            },
            {
                name: 'Moyen-Ogooué',
                cities: ['Lambaréné', 'Ndjolé', 'Fougamou', 'Mbigou']
            },
            {
                name: 'Ngounié',
                cities: ['Mouila', 'Ndendé', 'Fougamou', 'Mimongo']
            },
            {
                name: 'Nyanga',
                cities: ['Tchibanga', 'Mayumba', 'Ndindi', 'Mabanda']
            },
            {
                name: 'Ogooué-Ivindo',
                cities: ['Makokou', 'Booué', 'Ivindo', 'Zadie']
            },
            {
                name: 'Ogooué-Lolo',
                cities: ['Koulamoutou', 'Lastoursville', 'Pana', 'Lébamba']
            },
            {
                name: 'Ogooué-Maritime',
                cities: ['Port-Gentil', 'Gamba', 'Omboué', 'Ndougou']
            },
            {
                name: 'Woleu-Ntem',
                cities: ['Oyem', 'Bitam', 'Mitzic', 'Minvoul']
            }
        ]
    },
    {
        code: 'CG',
        name: 'Congo',
        phonePrefix: '+242',
        languages: ['fr'],
        regions: [
            {
                name: 'Brazzaville',
                cities: ['Brazzaville', 'Bacongo', 'Poto-Poto', 'Ouenzé']
            },
            {
                name: 'Pointe-Noire',
                cities: ['Pointe-Noire', 'Loandjili', 'Ngoyo', 'Tchiamba-Nzassi']
            },
            {
                name: 'Bouenza',
                cities: ['Madingou', 'Nkayi', 'Louvakou', 'Boko-Songho']
            },
            {
                name: 'Cuvette',
                cities: ['Owando', 'Makoua', 'Etoumbi', 'Kelle']
            },
            {
                name: 'Cuvette-Ouest',
                cities: ['Ewo', 'Kéllé', 'Mbama', 'Mbomo']
            },
            {
                name: 'Kouilou',
                cities: ['Loango', 'Madingo-Kayes', 'Mouyondzi', 'Tchiamba']
            },
            {
                name: 'Lékoumou',
                cities: ['Sibiti', 'Zanaga', 'Komono', 'Mayéyé']
            },
            {
                name: 'Likouala',
                cities: ['Impfondo', 'Dongou', 'Epena', 'Betou']
            },
            {
                name: 'Niari',
                cities: ['Dolisie', 'Mossendjo', 'Loubomo', 'Moutamba']
            },
            {
                name: 'Plateaux',
                cities: ['Djambala', 'Gamboma', 'Abala', 'Matsanga']
            },
            {
                name: 'Pool',
                cities: ['Kinkala', 'Mindouli', 'Boko', 'Kimba']
            },
            {
                name: 'Sangha',
                cities: ['Ouésso', 'Sembé', 'Souanké', 'Pikounda']
            }
        ]
    },
    {
        code: 'CD',
        name: 'République Démocratique du Congo',
        phonePrefix: '+243',
        languages: ['fr', 'sw', 'ln'],
        regions: [
            {
                name: 'Kinshasa',
                cities: ['Kinshasa', 'Mont-Ngafula', 'Lemba', 'Matete']
            },
            {
                name: 'Kongo-Central',
                cities: ['Matadi', 'Boma', 'Mbanza-Ngungu', 'Kasangulu']
            },
            {
                name: 'Kwango',
                cities: ['Kenge', 'Kasongo-Lunda', 'Popokabaka', 'Feshi']
            },
            {
                name: 'Kwilu',
                cities: ['Bandundu', 'Bulungu', 'Bagata', 'Idiofa']
            },
            {
                name: 'Mai-Ndombe',
                cities: ['Inongo', 'Kiri', 'Bolobo', 'Yumbi']
            },
            {
                name: 'Kasaï',
                cities: ['Luebo', 'Tshikapa', 'Ilebo', 'Mweka']
            },
            {
                name: 'Kasaï-Central',
                cities: ['Kananga', 'Lubao', 'Demba', 'Luiza']
            },
            {
                name: 'Kasaï-Oriental',
                cities: ['Mbuji-Mayi', 'Mwene-Ditu', 'Lupatapata', 'Tshilenge']
            },
            {
                name: 'Lomami',
                cities: ['Kabinda', 'Mwene-Ditu', 'Kongolo', 'Lubao']
            },
            {
                name: 'Sankuru',
                cities: ['Lusambo', 'Lodja', 'Kole', 'Katako-Kombe']
            },
            {
                name: 'Maniema',
                cities: ['Kindu', 'Kisangani', 'Punia', 'Walikale']
            },
            {
                name: 'Sud-Kivu',
                cities: ['Bukavu', 'Uvira', 'Baraka', 'Fizi']
            },
            {
                name: 'Nord-Kivu',
                cities: ['Goma', 'Butembo', 'Beni', 'Rutshuru']
            },
            {
                name: 'Ituri',
                cities: ['Bunia', 'Aru', 'Mahagi', 'Djugu']
            },
            {
                name: 'Haut-Uele',
                cities: ['Isiro', 'Watsa', 'Rungu', 'Faradje']
            },
            {
                name: 'Tshopo',
                cities: ['Kisangani', 'Ubundu', 'Bafwasende', 'Opala']
            },
            {
                name: 'Bas-Uele',
                cities: ['Buta', 'Aketi', 'Bondo', 'Poko']
            },
            {
                name: 'Nord-Ubangi',
                cities: ['Gbadolite', 'Bosobolo', 'Mobayi-Mbongo', 'Yakoma']
            },
            {
                name: 'Mongala',
                cities: ['Lisala', 'Bumba', 'Bongandanga', 'Makanza']
            },
            {
                name: 'Sud-Ubangi',
                cities: ['Gemena', 'Kungu', 'Libenge', 'Zongo']
            },
            {
                name: 'Équateur',
                cities: ['Mbandaka', 'Bolomba', 'Ingende', 'Basankusu']
            },
            {
                name: 'Tshuapa',
                cities: ['Boende', 'Ikela', 'Djolu', 'Monkoto']
            },
            {
                name: 'Tanganyika',
                cities: ['Kalemie', 'Kongolo', 'Kabalo', 'Manono']
            },
            {
                name: 'Haut-Lomami',
                cities: ['Kamina', 'Kipushi', 'Panda', 'Sakania']
            },
            {
                name: 'Lualaba',
                cities: ['Kolwezi', 'Lubumbashi', 'Likasi', 'Kipushi']
            },
            {
                name: 'Haut-Katanga',
                cities: ['Lubumbashi', 'Likasi', 'Kipushi', 'Sakania']
            }
        ]
    },
    {
        code: 'TD',
        name: 'Tchad',
        phonePrefix: '+235',
        languages: ['fr', 'ar'],
        regions: [
            {
                name: 'N\'Djamena',
                cities: ['N\'Djamena', 'Kousseri', 'Moundou', 'Sarh']
            },
            {
                name: 'Chari-Baguirmi',
                cities: ['N\'Djamena', 'Bongor', 'Koumra', 'Dourbali']
            },
            {
                name: 'Mayo-Kebbi Est',
                cities: ['Bongor', 'Fianga', 'Léré', 'Pala']
            },
            {
                name: 'Mayo-Kebbi Ouest',
                cities: ['Pala', 'Laimé', 'Léré', 'Fianga']
            },
            {
                name: 'Guéra',
                cities: ['Mongo', 'Bitkine', 'Melfi', 'Mangalmé']
            },
            {
                name: 'Hadjer-Lamis',
                cities: ['Massakory', 'Massaguet', 'Bokoro', 'Mango']
            },
            {
                name: 'Wadi Fira',
                cities: ['Biltine', 'Arada', 'Iriba', 'Am Dam']
            },
            {
                name: 'Lac',
                cities: ['Bol', 'Ati', 'Ngouri', 'Fianga']
            },
            {
                name: 'Kanem',
                cities: ['Mao', 'Moussoro', 'Rukunu', 'Wadjigui']
            },
            {
                name: 'Batha',
                cities: ['Ati', 'Oum Hadjer', 'Am Dam', 'Ngama']
            },
            {
                name: 'Barh el Gazel',
                cities: ['Moussoro', 'Bousso', 'Kaya', 'Salal']
            },
            {
                name: 'Ouaddaï',
                cities: ['Abéché', 'Adré', 'Am Dam', 'Gozi Beïda']
            },
            {
                name: 'Sila',
                cities: ['Gozi Beïda', 'Koukou', 'Mao', 'Haraze']
            },
            {
                name: 'Tandjilé',
                cities: ['Laï', 'Kélo', 'Béré', 'Dangla']
            },
            {
                name: 'Mandoul',
                cities: ['Koumra', 'Moïssala', 'Bédjondo', 'Bébédjia']
            },
            {
                name: 'Moyen-Chari',
                cities: ['Sarh', 'Koumra', 'Kyabé', 'Moïssala']
            },
            {
                name: 'Logone Oriental',
                cities: ['Doba', 'Gounou Gaya', 'Beïnamar', 'Guelendeng']
            },
            {
                name: 'Logone Occidental',
                cities: ['Moundou', 'Benoye', 'Laokassy', 'Bongor']
            }
        ]
    },
    {
        code: 'CF',
        name: 'République Centrafricaine',
        phonePrefix: '+236',
        languages: ['fr', 'sg'],
        regions: [
            {
                name: 'Bangui',
                cities: ['Bangui', 'Bimbo', 'Bégoua']
            },
            {
                name: 'Bamingui-Bangoran',
                cities: ['Ndélé', 'Bamingui', 'Koui', 'Ouadda']
            },
            {
                name: 'Basse-Kotto',
                cities: ['Mobaye', 'Alindao', 'Mingala', 'Kembé']
            },
            {
                name: 'Haute-Kotto',
                cities: ['Bria', 'Ouadda', 'Yalinga', 'Zémio']
            },
            {
                name: 'Haut-Mbomou',
                cities: ['Obo', 'Zémio', 'Mboki', 'Bangassou']
            },
            {
                name: 'Kémo',
                cities: ['Sibut', 'Dékoa', 'Mbaïki', 'Grimari']
            },
            {
                name: 'Lobaye',
                cities: ['Mbaïki', 'Boda', 'Boali', 'Damara']
            },
            {
                name: 'Mambéré-Kadéï',
                cities: ['Berbérati', 'Carnot', 'Gamboula', 'Sosso-Nakombo']
            },
            {
                name: 'Mbomou',
                cities: ['Bangassou', 'Gambo', 'Ouango', 'Rafai']
            },
            {
                name: 'Nana-Gribizi',
                cities: ['Kaga Bandoro', 'Mbrès', 'Paoua', 'Markounda']
            },
            {
                name: 'Nana-Mambéré',
                cities: ['Bouar', 'Baoro', 'Baboua', 'Bozoum']
            },
            {
                name: 'Ombella-M\'Poko',
                cities: ['Bozoum', 'Boali', 'Damara', ' Yaloké']
            },
            {
                name: 'Ouaka',
                cities: ['Bambari', 'Grimari', 'Ippy', 'Kembé']
            },
            {
                name: 'Ouham',
                cities: ['Bossangoa', 'Bouca', 'Kabo', 'Batangafo']
            },
            {
                name: 'Ouham-Pendé',
                cities: ['Bozoum', 'Paoua', 'Bocaranga', 'Nanga Boguila']
            },
            {
                name: 'Sangha-Mbaéré',
                cities: ['Nola', 'Carnot', 'Bayanga', 'Saléa']
            },
            {
                name: 'Vakaga',
                cities: ['Birao', 'Ouadda', 'Aoukal', 'Bamingui']
            }
        ]
    },
    {
        code: 'GQ',
        name: 'Guinée Équatoriale',
        phonePrefix: '+240',
        languages: ['es', 'fr', 'pt'],
        regions: [
            {
                name: 'Bioko Norte',
                cities: ['Malabo', 'Luba', 'Riaba', 'Baney']
            },
            {
                name: 'Bioko Sur',
                cities: ['Luba', 'Riaba', 'Baney', 'Ureca']
            },
            {
                name: 'Región Continental',
                cities: ['Bata', 'Ebebiyín', 'Mongomo', 'Mikomeseng']
            },
            {
                name: 'Djibloho',
                cities: ['Ciudad de la Paz', 'Djibloho', 'Acurenam', 'Nsok']
            },
            {
                name: 'Anisoc',
                cities: ['Ebebiyín', 'Mikomeseng', 'Nsok', 'Nkue']
            },
            {
                name: 'Centro Sur',
                cities: ['Evinayong', 'Niefang', 'Nsork', 'Akurenam']
            },
            {
                name: 'Kie-Ntem',
                cities: ['Ebebiyín', 'Mikomeseng', 'Nsok', 'Nkue']
            },
            {
                name: 'Litoral',
                cities: ['Cogo', 'Bata', 'Mbini', 'Corisco']
            },
            {
                name: 'Wele-Nzas',
                cities: ['Mongomo', 'Añisoc', 'Nsork', 'Nkue']
            }
        ]
    },
    {
        code: 'ST',
        name: 'Sao Tomé-et-Principe',
        phonePrefix: '+239',
        languages: ['pt'],
        regions: [
            {
                name: 'Água Grande',
                cities: ['São Tomé', 'Trindade', 'Santana', 'Alto São João']
            },
            {
                name: 'Cantagalo',
                cities: ['Santana', 'Ribeira Afonso', 'São João dos Angolares', 'Trindade']
            },
            {
                name: 'Caué',
                cities: ['São João dos Angolares', 'Santana', 'Trindade', 'Ribeira Afonso']
            },
            {
                name: 'Lembá',
                cities: [' Neves', 'Santa Catarina', 'Trindade', 'Santana']
            },
            {
                name: 'Lobata',
                cities: ['Guadalupe', 'Santo António', 'Trindade', 'Santana']
            },
            {
                name: 'Mé-Zóchi',
                cities: ['Trindade', 'Santana', 'São João dos Angolares', 'Ribeira Afonso']
            },
            {
                name: 'Pagué',
                cities: ['São João dos Angolares', 'Santana', 'Trindade', 'Ribeira Afonso']
            }
        ]
    }
];

// Fonctions utilitaires
export const getCountryByCode = (code: string): Country | undefined => {
    return africanCountries.find(country => country.code === code);
};

export const getRegionsByCountry = (countryCode: string): Region[] => {
    const country = getCountryByCode(countryCode);
    return country ? country.regions : [];
};

export const getCitiesByRegion = (countryCode: string, regionName: string): string[] => {
    const regions = getRegionsByCountry(countryCode);
    const region = regions.find(r => r.name === regionName);
    return region ? region.cities : [];
};

export const validateAfricanPhone = (phone: string, countryCode: string): boolean => {
    const country = getCountryByCode(countryCode);
    if (!country) return false;

    // Supprimer les espaces et caractères spéciaux
    const cleanPhone = phone.replace(/[\s\-\(\)]/g, '');

    // Vérifier le préfixe
    if (!cleanPhone.startsWith(country.phonePrefix)) {
        return false;
    }

    // Vérifier la longueur (généralement 9-12 chiffres après le préfixe)
    const numberPart = cleanPhone.substring(country.phonePrefix.length);
    return /^\d{6,10}$/.test(numberPart);
};

export const formatAfricanPhone = (phone: string, countryCode: string): string => {
    const country = getCountryByCode(countryCode);
    if (!country) return phone;

    const cleanPhone = phone.replace(/[\s\-\(\)]/g, '');
    const prefix = country.phonePrefix;
    const numberPart = cleanPhone.replace(prefix, '');

    // Formatage basique
    if (numberPart.length === 9) {
        return `${prefix} ${numberPart.slice(0, 2)} ${numberPart.slice(2, 5)} ${numberPart.slice(5)}`;
    }

    return `${prefix} ${numberPart}`;
};